module.exports = __webpack_public_path__ + "img/LOCK.8e69699c.svg";